import { getOccupancyText } from 'components/Recommendations/utils/getOccupancyText'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { generateRoomOccupants } from 'lib/offer/occupancyUtils'
import { createSelector } from 'reselect'

import { formatDynamicDateRange } from 'lib/datetime/dateUtils'

export const getCurrenctOccupancyLabel = createSelector(
  (offerPageState: OfferPageState) => offerPageState.offer!,
  (offerPageState: OfferPageState) => offerPageState.rooms,
  (offer, rooms) => {
    const roomOccupants = rooms || [generateRoomOccupants()]
    return getOccupancyText(roomOccupants, offer.saleUnit)
  },
)

export const getCurrentDateLabel = createSelector(
  (offerPageState: OfferPageState) => offerPageState.checkInDate,
  (offerPageState: OfferPageState) => offerPageState.checkOutDate,
  (checkIn, checkOut) => {
    return formatDynamicDateRange(checkIn, checkOut)
  },
)

export const getDatesOccupancyLabel = createSelector(
  getCurrentDateLabel,
  getCurrenctOccupancyLabel,
  (dateLabel, occupancyLabel) => {
    return `${dateLabel}, ${occupancyLabel}`
  },
)
